import createPromise from "helpers/createPromise";
import WidgetConfig from "helpers/init/WidgetConfig";
import loadLocalTCFConsentCookie from "./loadLocalTCFConsent";
import { SavedConsentTimestamp } from "types/consent";
import type { SavedACString, SavedTCFConsent, SavedTCString } from "../TCFConsentProvider/types";

// this function loads tcf consent from storage
const loadTCFConsentFromStorage = (widgetConfig: WidgetConfig) => {
  // TODO: HANDLE BULK FOR FUTURE
  return createPromise<null | [SavedTCFConsent, SavedConsentTimestamp, SavedTCString, SavedACString]>(
    (resolve) => {
      return resolve(loadLocalTCFConsentCookie(widgetConfig));
    }
  );
};

export default loadTCFConsentFromStorage;
